import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";

export const Header = ({ onOpenAuth }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const logoDestination = user ? "/dashboard" : "/";
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      style={{ background: "#1a1a18", position: "sticky", top: 0, zIndex: 100 }}
    >
      <div
        className="mx-auto flex items-center justify-between"
        style={{ maxWidth: 1100, height: 56, padding: "0 24px" }}
      >
        <a
          href={logoDestination}
          data-testid="brand-logo"
          aria-label={user ? "GuMi, go to dashboard" : "GuMi, go to home"}
          style={{ fontSize: 20, fontWeight: 700, color: "white" }}
          onClick={(e) => {
            e.preventDefault();
            navigate(logoDestination);
          }}
        >
          Gu<span style={{ color: "#1D9E75" }}>Mi</span>
        </a>

        <div className="flex items-center gap-5">
          <a
            href="mailto:support@gumiscore.com"
            data-testid="nav-contact"
            className="font-body hidden sm:inline-block transition-colors"
            style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}
            onMouseEnter={(e) => { e.currentTarget.style.color = "white"; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.6)"; }}
          >
            Contact
          </a>
          <button
            type="button"
            data-testid="nav-signin"
            onClick={() => (onOpenAuth ? onOpenAuth("login") : navigate("/login"))}
            className="font-body hidden sm:inline-block transition-colors"
            style={{ color: "rgba(255,255,255,0.6)", fontSize: 13, background: "none", border: 0, cursor: "pointer" }}
            onMouseEnter={(e) => { e.currentTarget.style.color = "white"; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.6)"; }}
          >
            Sign in
          </button>
          <button
            type="button"
            data-testid="nav-get-started"
            onClick={() => (onOpenAuth ? onOpenAuth("register") : navigate("/register"))}
            className="font-body inline-flex items-center justify-center"
            style={{
              background: "#1D9E75",
              color: "white",
              borderRadius: 8,
              padding: "8px 18px",
              fontSize: 13,
              fontWeight: 600,
              minHeight: 44,
            }}
          >
            Get started →
          </button>
          <button
            type="button"
            data-testid="nav-menu-button"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="Open menu"
            aria-expanded={menuOpen}
            className="sm:hidden inline-flex items-center justify-center"
            style={{ width: 36, height: 36, background: "none", border: 0, color: "white", fontSize: 20, cursor: "pointer" }}
          >
            ☰
          </button>
        </div>
      </div>

      {menuOpen && (
        <div
          role="menu"
          data-testid="nav-mobile-menu"
          className="sm:hidden"
          style={{ background: "#1a1a18", borderTop: "1px solid rgba(255,255,255,0.1)", padding: "12px 24px 16px" }}
        >
          <button
            type="button"
            role="menuitem"
            data-testid="nav-signin-mobile"
            onClick={() => {
              setMenuOpen(false);
              onOpenAuth ? onOpenAuth("login") : navigate("/login");
            }}
            className="font-body block w-full text-left py-2"
            style={{ color: "rgba(255,255,255,0.8)", fontSize: 14, background: "none", border: 0, cursor: "pointer" }}
          >
            Sign in
          </button>
          <a
            role="menuitem"
            data-testid="nav-contact-mobile"
            href="mailto:support@gumiscore.com"
            onClick={() => setMenuOpen(false)}
            className="font-body block w-full py-2"
            style={{ color: "rgba(255,255,255,0.8)", fontSize: 14 }}
          >
            Contact
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
